import React from 'react';
import {
  loSearchColumns,
  QUERY_KEYS,
  vatTuSearchColumns,
  viTriSearchColumns,
  warehouseSearchColumns
} from '@/constants';
import { KhoHang, Lo, VatTu, type ViTriKho } from '@/types/schemas';
import { SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { SearchFieldActions, SearchFieldState } from '../../hooks';
import { Label } from '@/components/ui/label';

interface DetailTabProps {
  searchFieldState: SearchFieldState;
  searchFieldActions: SearchFieldActions;
}

const DetailTab = ({ searchFieldState, searchFieldActions }: DetailTabProps) => {
  return (
    <div className='space-y-3 p-4'>
      {/* Mã vật tư */}
      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Mã vật tư</Label>
        <SearchField<VatTu>
          searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
          searchColumns={vatTuSearchColumns}
          columnDisplay='ma_vt'
          displayRelatedField='ten_vt'
          dialogTitle='Danh mục vật tư'
          relatedFieldValue={searchFieldState.vatTu?.ten_vt}
          value={searchFieldState.vatTu?.ma_vt}
          onRowSelection={searchFieldActions.setVatTu}
          className='w-100'
        />
      </div>

      {/* Mã kho */}
      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Mã kho</Label>
        <SearchField<KhoHang>
          searchEndpoint={`/${QUERY_KEYS.KHO_HANG}/`}
          searchColumns={warehouseSearchColumns}
          columnDisplay='ma_kho'
          displayRelatedField='ten_kho'
          dialogTitle='Danh mục kho hàng'
          relatedFieldValue={searchFieldState.khoHang?.ten_kho}
          onRowSelection={searchFieldActions.setKhoHang}
          className='w-100'
        />
      </div>

      {/* Mã lô */}
      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Mã Lô</Label>
        <SearchField<Lo>
          searchEndpoint={`/${QUERY_KEYS.LO}/`}
          searchColumns={loSearchColumns}
          columnDisplay='ma_lo'
          displayRelatedField='ten_lo'
          dialogTitle='Danh mục lô'
          value={searchFieldState.lo?.ma_lo}
          relatedFieldValue={searchFieldState.lo?.ten_lo}
          onRowSelection={searchFieldActions.setLo}
          className='w-100'
        />
      </div>

      {/* Mã vị trí */}
      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Mã vị trí</Label>
        <SearchField<ViTriKho>
          searchEndpoint={`/${QUERY_KEYS.VI_TRI}/`}
          searchColumns={viTriSearchColumns}
          columnDisplay='ma_vi_tri'
          displayRelatedField='ten_vi_tri'
          dialogTitle='Danh mục vị trí kho hàng'
          value={searchFieldState.viTri?.ma_vi_tri}
          relatedFieldValue={searchFieldState.viTri?.ten_vi_tri}
          onRowSelection={searchFieldActions.setViTri}
          className='w-100'
        />
      </div>
    </div>
  );
};

export default DetailTab;
